import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Hero from './components/Hero.jsx';
import Header from './components/Header/Header.jsx';
import BodiosYakDown from './components/BodiosYakDown.jsx';
import Footer from './components/Footer/Footer.jsx';
import DetailBodios from './components/MenuDetail/DetailBodios.jsx';
import About from './components/About/AboutUs.jsx';
import YakDetail from './components/YaKDetail/YakDetail.jsx';
import Social from './components/Social/Social.jsx';
import { CollectionPage } from './components/Category/CollectionPage.jsx';
import { BrandStory } from './components/Core/BrandStory.jsx';
import { Artisan } from './components/Artisan/Artisan.jsx';
import { BrandDescription } from './components/BrandDescription/BrandDescription.jsx';
import BoutiqueHeader from './components/BoutiqueHeader/BoutiqueHeader.jsx';
import { ImageGallery } from './components/Three/ImageGallery.jsx';
import HeaderWhite from './components/HeaderLing/HeaderWhite.jsx';
import JournalLayout from './components/Journal/JournalLayout.jsx';
import { ProductDetailPage } from "./components/Category/ProductDetailPage.jsx";
import CartPage from './components/Cart/CartPage.jsx';
import CheckoutPage from './components/Cart/CheckoutPage.jsx';
import SuccessPage from "./components/Cart/SuccessPage";
import { CartProvider } from './context/CartContext';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Router>
      <CartProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={
              <>
                <Header />
                <Hero />
                <BoutiqueHeader />
                <BodiosYakDown />
                <BrandDescription />
                <ImageGallery />
                <Artisan />
                <BrandStory />
              </>
            } />
            
            <Route path="/bodios" element={<><HeaderWhite /><DetailBodios /></>} />
            <Route path="/journal" element={<><HeaderWhite /><JournalLayout /></>} />
            <Route path="/about" element={<><HeaderWhite /><About /></>} />
            <Route path="/yak" element={<><HeaderWhite /><YakDetail /></>} />
            <Route path="/social" element={<><HeaderWhite /><Social /></>} />
            <Route path="/category/:category" element={<><HeaderWhite /><CollectionPage /></>} />
            <Route path="/product/:productId" element={<><HeaderWhite /><ProductDetailPage /></>} />
            <Route path="/cart" element={<><HeaderWhite /><CartPage /></>} />
            <Route path="/checkout" element={<><HeaderWhite /><CheckoutPage /></>} />
            <Route path="/success" element={<SuccessPage />} />
          </Routes>
          
          <Footer />
          <ToastContainer position="top-center" />
        </div>
      </CartProvider>
    </Router>
  );
}

export default App;